<div class="line-header">
	<div class="cancel-block" (click)="cancelButton()">
		Cancel
	</div>
	<div class="title-block">
		Line Item
	</div>
	<div class="add-block" (click)="saveButton()">
		Continue
	</div>
</div>

<div class="line-content-block">
	<div class="form-line">
		<div class="line-leftside">
			Services
		</div>
		<div class="line-rightside" (click)="openChooserServs()">
			{{tempService?.name}}

			<span class="material-icons">
				arrow_forward_ios
			</span>
		</div>
	</div>
	<div class="form-line">
		<div class="line-leftside">
			Quantity
		</div>
		<div class="line-rightside">
			<input #inputik1 pInputText BlockLateralArrowNavigation class="num-input" placeholder="" type="tel" autocomplete="new-password"
				[(ngModel)]="tempQt" name="qty" [tabIndex]="-1" (click)="selectAll(inputik1)">
		</div>
	</div>
	<div class="form-line">
		<div class="line-leftside">
			Rate
		</div>
		<div class="line-rightside">
			<input #inputik2 pInputText BlockLateralArrowNavigation class="num-input" placeholder="" type="tel" autocomplete="new-password"
				[(ngModel)]="tempRate" name="rate" [tabIndex]="-1" (click)="selectAll(inputik2)">
		</div>
	</div>
	<div class="form-label">
		<div class="line-leftside">
			Amount
		</div>
		<div class="line-rightside">
			${{tempQt * tempRate}}
		</div>
	</div>
	<div class="form-line">
		<div class="line-leftside">
			Class
		</div>
		<div class="line-rightside" (click)="openChooserClasses()">
			{{tempClass?.name}}

			<span class="material-icons">
				arrow_forward_ios
			</span>
		</div>
	</div>
	<div class="textarea-line">
		<textarea class="textarea-input" [(ngModel)]="tempDesc" [tabIndex]="-1"></textarea>
	</div>
</div>
